import qs from 'qs';

const useSetQueryParams = (location, obj) => {
  const { pathname } = location;

  const urlParams = qs.parse(location.search, { ignoreQueryPrefix: true });
  const result = { ...urlParams, ...obj };
  window.sessionStorage.setItem(pathname, JSON.stringify(result));

  const queryString = new URLSearchParams(result).toString();
  const newPath = `${pathname}?${queryString}`;
  window.history.replaceState({ path: newPath }, '', newPath);

  return result;
};
export default useSetQueryParams;
